import get from "../../src/helpers/get";

import socialLinks from "./socialLinks.js";
import lowerEntries from "../../src/helpers/lowerEntries";

import {
  FEMALE,
  DEFAULT
} from "../../src/template/state/modules/layout/constants";

export const getLanguage = languageCode => languageCode.split("-")[0];

export const getSocialLinks = params => {
  const { floor, storeCode } = lowerEntries(params);

  if (!floor || !storeCode) {
    throw new Error(
      "cannot retrieve social networks without storeCode and floor"
    );
  }

  const defaultedFloor = floor === DEFAULT ? FEMALE : floor;
  const linksPath = `${storeCode}.${defaultedFloor}`;

  return get(socialLinks, linksPath);
};
